// Components
import { useCallback, useEffect } from 'react';
import DiscardConfirmation, {
  useDiscardConfirmation,
} from 'components/DiscardConfirmation';
// Utils
import { getText } from 'i18n/intl';
import { requestObjectTypes } from 'slices/objectTypes.slice';
import { fetchReservationTemplates } from 'slices/reservationTemplate.slice';
import { useAppDispatch } from 'slices/store';
// Slices
import {
  checkTimeRuleSaveDisabled,
  fetchTimeRules,
} from 'slices/timeRule.slice';
import { DefaultContentLayout } from '@timeedit/ui-components';
import TimeRuleDrawer from './TimeRuleDrawer';
import TimeRuleList from './TimeRuleList';

const TimeRulePage = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(fetchTimeRules());
    dispatch(requestObjectTypes());
    dispatch(fetchReservationTemplates());
  }, []);

  const [
    openDiscardDialog,
    onCloseDiscardDialog,
    confirmFn,
    confirmDiscardChanged,
  ] = useDiscardConfirmation();

  const confirmDiscardPaddingChanges = useCallback(
    (isFirstDrawer: boolean, actionFn: () => void) => {
      const isFieldRelationDisabled = dispatch(
        checkTimeRuleSaveDisabled(isFirstDrawer)
      );
      if (!isFieldRelationDisabled) {
        return confirmDiscardChanged(actionFn);
      }
      actionFn();
    },
    []
  );

  return (
    <DefaultContentLayout
      title={getText('time_rules')}
      subtitle={getText('time_rules_subtitle')}
    >
      <div className="inner-content--wrapper">
        <TimeRuleList
          confirmDiscardPaddingChanges={confirmDiscardPaddingChanges}
        />
        <TimeRuleDrawer
          confirmDiscardPaddingChanges={confirmDiscardPaddingChanges}
        />
      </div>
      <DiscardConfirmation
        open={openDiscardDialog}
        onClose={onCloseDiscardDialog}
        confirmFn={confirmFn}
      />
    </DefaultContentLayout>
  );
};

export default TimeRulePage;
